<template>
    <div>
        <div class="no-data" v-if="noData">该仓位暂无货物</div>
        <div v-else>
            <div class="section-title">商品明细</div>
            <div class="edit-ctn">
                <!--      table title      -->
                <div class="div-table-row table-title">
                    <div class="div-table-cell" style="width: 25%">汽配编码</div>
                    <div class="div-table-cell" style="width: 20%">汽配名称</div>
                    <div class="div-table-cell" style="width: 17%">适用车型</div>
                    <div class="div-table-cell" style="width: 10%">商品总数</div>
                    <div class="div-table-cell" style="width: 5%">单位</div>
                    <div class="div-table-cell" style="width: 10%">已有标签数</div>
                    <div class="div-table-cell" style="width: 10%">未打标签数</div>
                    <div class="div-table-cell" style="width: 7%">操作</div>
                </div>
                <div class="table-main">
                    <div :key="index" class="div-table-row table-item" v-for="(item, index) in dataList">
                        <!--        编码            -->
                        <div class="div-table-cell" style="width: 25%">
                            <el-tooltip effect="dark" :content="item.APCode" placement="top">
                                <span>{{ item.APCode }}</span>
                            </el-tooltip>
                        </div>
                        <!--        汽配名称            -->
                        <div class="div-table-cell" style="width: 20%; padding-right: 6px">
                            <el-tooltip effect="dark" :content="item.GoodName" placement="top">
                                <span>{{ item.GoodName }}</span>
                            </el-tooltip>
                        </div>
                        <!--        适用车型            -->
                        <div class="div-table-cell" style="width: 17%; padding-right: 6px">
                            <el-tooltip effect="dark" :content="item.AutoSerise" placement="top">
                                <span>{{ item.AutoSerise }}</span>
                            </el-tooltip>
                        </div>
                        <!--        数量            -->
                        <div class="div-table-cell" style="width: 10%">
                            <el-tooltip effect="dark" :content="item.Count.toString()" placement="top">
                                <span>{{ item.Count }}</span>
                            </el-tooltip>
                        </div>
                        <!--        单位         -->
                        <div class="div-table-cell" style="width: 5%">{{ item.Unit }}</div>
                        <div class="div-table-cell" style="width: 10%">
                            <el-tooltip effect="dark" :content="item.PrintedCount.toString()" placement="top">
                                <span>{{ item.PrintedCount }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 10%">
                            <el-tooltip effect="dark" :content="item.UnprintCount.toString()" placement="top">
                                <span>{{ item.UnprintCount }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 7%">
                            <el-button v-if="item.UnprintCount > 0" title="打印该商品的标签" size="mini" type="text" @click="printGoodsLabels(item)">打印标签</el-button>
                        </div>
                    </div>
                    <div class="div-table-row table-item">
                        <div class="div-table-cell" style="width: 25%"></div>
                        <div class="div-table-cell" style="width: 20%"></div>
                        <div class="div-table-cell" style="width: 17%"></div>
                        <div class="div-table-cell" style="width: 10%">
                            <el-tooltip effect="dark" :content="allNum.toString()" placement="top">
                                <span>{{ allNum }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 5%"></div>
                        <div class="div-table-cell" style="width: 10%">
                            <el-tooltip effect="dark" :content="allPrintedNum.toString()" placement="top">
                                <span>{{ allPrintedNum }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 10%">
                            <el-tooltip effect="dark" :content="allUnprintNum.toString()" placement="top">
                                <span>{{ allUnprintNum }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 7%"></div>
                    </div>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false" title="仓库商品标签打印配置" :visible.sync="showPrintSingleLabelsDialog" width="600px" append-to-body>
                <div class="dialog-content" v-if="showPrintSingleLabelsDialog">
                    <printSpaceGoodsLabelSet @closeDialog="closePrintSingleLabelsDialog" :ShelfSpaceId="ShelfSpaceId" :EntpGoodsId="entpGoodsId"></printSpaceGoodsLabelSet>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import printSpaceGoodsLabelSet from '@/components/business/goods/printSpaceGoodsLabelSet.vue';
export default {
    name: '',
    props: ['ShelfSpaceId', 'WarehouseId'],
    components: {
        printSpaceGoodsLabelSet
    },
    data() {
        return {
            noData: false,
            allNum: '',
            allUnprintNum: '',
            allPrintedNum: '',
            dataList: [],
            entpGoodsId: '',
            showPrintSingleLabelsDialog: false,
            searchData: {
                ShelfSpaceId: this.ShelfSpaceId,
                WarehouseId: this.WarehouseId
            }
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoodsLabels/GetSpaceGoodsLabelDatas',
                    data: this.searchData
                })
                .then(res => {
                    if (!res.data || res.data.length == 0) {
                        this.noData = true;
                        return;
                    }
                    let DetailList = res.data;
                    let _allNum = 0;
                    let _allPrintedNum = 0;
                    let _allUnprintNum = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrintedNum += Number(DetailList[i].PrintedCount);
                        _allUnprintNum += Number(DetailList[i].UnprintCount);
                    }
                    this.allNum = _allNum;
                    this.allPrintedNum = _allPrintedNum;
                    this.allUnprintNum = _allUnprintNum;
                    this.dataList = DetailList;
                });
        },
        printGoodsLabels(row) {
            let that = this;
            if (row) {
                that.entpGoodsId = row.EntpTempGoodsId;
                that.showPrintSingleLabelsDialog = true;
            } else {
                that.$util.warningMsg('请选择商品进行打印标签');
                return;
            }
        },
        closePrintSingleLabelsDialog() {
            this.entpGoodsId = '';
            this.showPrintSingleLabelsDialog = false;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.form-main {
    display: flex;
    > div {
        width: 33.33%;
    }
}
.inventory-title {
    line-height: 1.2;
    flex-direction: column;
    > div:nth-child(1) {
        width: 100%;
        border-bottom: 1px solid @border3Color;
    }
    > div:nth-child(2) {
        width: 100%;
        display: flex;
        > div {
            width: 33.33%;
        }
    }
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 20px;
    margin-bottom: 20px;
}
.option-content {
    display: flex;
    line-height: 30px;
}
.add-btn {
    position: absolute;
    right: -40px;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 0;
    z-index: 2;
}
.business-content-main {
    padding-right: 80px;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
    height: 36px;
}
.table-item {
    height: 36px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
}
</style>
